import React from 'react';
import { useDossierContext } from 'common-app/dossier';
import { ConsentGroupStatus } from '@isyc-react/oc-api/queries/consents';
import { ConsentsGroupForm } from './consents-group-form.component';
import { ErrorLayout } from 'layout/error';
const filterConsentsGroups = (groups) => groups.filter(cg => cg.statusTree.treelevel1 === ConsentGroupStatus.NEW);
// TODO i18n
export const DossierConsents = () => {
    const { dossier } = useDossierContext();
    const consentsGroup = React.useMemo(() => {
        var _a;
        return dossier ? filterConsentsGroups((_a = dossier.consentsGroup) !== null && _a !== void 0 ? _a : []) : [];
    }, [dossier]);
    return (React.createElement(React.Fragment, null, dossier ? (React.createElement(ConsentsGroupForm, { consentsGroup: consentsGroup })) : (React.createElement(ErrorLayout, null,
        React.createElement("h3", { className: 'text-primary consents-group-title-error' }, "No dossier"),
        React.createElement("p", null, "No dossier with consents groups")))));
};
